import _ from 'underscore';

import { FilterPanelService, ISelectFilterDefinition, ISelectFilterDefinitionMap, ISelectFilterDefinitionOption } from '~src/spacesPlatform/services/FilterPanelService';

import { IIdentityPool } from '../serverApi/types/identityPools/IIdentityPool';
import { IdentityPoolService } from '../services/IdentityPoolService';

export module IdentityPoolFilterHelper {

  export async function identityPoolDefinition(): Promise<ISelectFilterDefinition<string>>  {

    let identityPools: IIdentityPool[]  = await IdentityPoolService.tryFetchActiveIdentityPools();
    const options: ISelectFilterDefinitionOption<string>[] = [
      {
        value: 'all',
        translate: 'identityPool_All'
      },
      {
        value: 'DEFAULT',
        translate: 'identityPool_Default'
      }
    ];

    let paramToValueMap:  ISelectFilterDefinitionMap<string> = {
        '': 'all',
        'DEFAULT': 'DEFAULT',
        'NONE': 'NONE'
    };

    _.each(identityPools, (identityPool: IIdentityPool) => {
        options.push({
          value: identityPool.name,
          translate: '',
          overrideLabel: identityPool.name
        });

        paramToValueMap[identityPool.id] = identityPool.name;
    });
    options.push({
        value: 'NONE',
        translate: 'identityPool_None'
    });


    return FilterPanelService.dropdownSelectFilterDefinition(
        'identityPool',
        paramToValueMap,
        options,
        'detail'
    );
  }

}
